import { BasePostInputModel } from "src/models/http/InputModel/BasePostInputModel"

export class SeriesSeriesIdFavoritePostInputModel extends BasePostInputModel {
  constructor(private series_id: string) {
    super()
  }

  get pathParams(): Record<string, string> {
    return {
      series_id: this.series_id,
    }
  }
}
